/*
 * @Author:   wuchenge
 * @Date:     2022-03-31 11:15:09
 * @Last      Modified by:   无尘阁
 * @Last      Modified time: 2022-03-31 11:17:58
 */
import { useState, useEffect } from "react";
import { connect } from "react-redux";
import { http } from "utils/http";


import Row from 'react-bootstrap/Row';
import Image from 'react-bootstrap/Image';
import Button from 'react-bootstrap/Button';

import { actions } from "../store";

import { 
  TopicWrapper, 
  TopicItem
} from "../style";

const Topic = ({
  handleOnClick,
  search_label_ids
}) => {
  const [list, setList] = useState([]);
  useEffect(() => {
    http("/labels").then((res) => {
      setList(res);
    });
  }, []);

  return (
    <TopicWrapper>
      {list?.map((item) => (
        <TopicItem 
          onClick = {() => handleOnClick(item.id.toString(), search_label_ids)} 
          key={item.id} 
          className={`${search_label_ids.indexOf(item.id.toString()) !== -1 ? "active" : null}`}
        >
          <img className={`topic-pic`} src={item.img} alt="" />
          {item.title}
        </TopicItem>
      ))}
    </TopicWrapper>
  );
};

const mapState = (state) => ({
  search_label_ids: state.getIn(["home", "search_label_ids"]) == "" ? [] : state.getIn(["home", "search_label_ids"]).split(','),
});

const mapDispatch = (dispatch) => {
  return {
    handleOnClick(id, ids) {
      let index = ids.indexOf(id);
      if(index == -1) {
        ids.push(id);
      } else {
        ids.splice(index, 1);
      }

      dispatch(actions.changHomeTopics(ids));
    }
  };
};

export default connect(mapState, mapDispatch)(Topic);
